// Tab List (FilterCategory)
export const TabList = [
	// {
	// 	id: "ongoing",
	// 	title: "Ongoing applications",
	// },
	{
		id: "submitted",
		title: "Submitted Applications",
	},
	{
		id: "completed",
		title: "Completed Applications",
	},
	{ id: "savings", title: "Travel Savings" },
];

// Table Head Cells
export const OngoingHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "fullName", title: "FULL NAME", width: 120 },
	{ field: "userId.phone", title: "PHONE NUMBER", width: 75 },
	{ field: "userId.email", title: "EMAIL", width: 60 },
	{ field: "destinationCountry", title: "DESTINATION", width: 60 },
	{ field: "amountToRaise", title: "AMOUNT TO RAISE", width: 120 },
	{ field: "expectedDepartureDate", title: "DEPARTURE", width: 130 },
	{ field: "lengthOfStay", title: "TENURE", width: 60 },
	{ field: "interest", title: "INTEREST", width: 60 },
	{ field: "approvalStatus", title: "APPROVAL", width: 60 },
	{ field: "", title: "ACTION", sortable: false, width: 70 },
];

export const SubmittedHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "fullName", title: "FULL NAME", width: 120 },
	{ field: "userId.phone", title: "PHONE NUMBER", width: 75 },
	{ field: "userId.email", title: "EMAIL", width: 60 },
	{ field: "destinationCountry", title: "DESTINATION", width: 60 },
	{ field: "amountToRaise", title: "AMOUNT TO RAISE", width: 120 },
	{ field: "expectedDepartureDate", title: "DEPARTURE", width: 130 },
	{ field: "lengthOfStay", title: "TENURE", width: 60 },
	{ field: "interest", title: "INTEREST", width: 60 },
	{ field: "approvalStatus", title: "APPROVAL", width: 60 },
	{ field: "", title: "ACTION", sortable: false, width: 70 },
];

export const CompletedHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "fullName", title: "FULL NAME", width: 120 },
	{ field: "userId.phone", title: "PHONE NUMBER", width: 75 },
	{ field: "userId.email", title: "EMAIL", width: 60 },
	{ field: "destinationCountry", title: "DESTINATION", width: 60 },
	{ field: "amountToRaise", title: "AMOUNT TO RAISE", width: 120 },
	{ field: "expectedDepartureDate", title: "DEPARTURE", width: 130 },
	{ field: "lengthOfStay", title: "TENURE", width: 60 },
	{ field: "interest", title: "INTEREST", width: 60 },
	{ field: "approvalStatus", title: "APPROVAL", width: 60 },
	{ field: "", title: "ACTION", sortable: false, width: 70 },
];
